import moment from 'moment-timezone';

function getHideRoundEnd(range, timezone = 'Australia/Sydney') {
  // Legacy single-day entries contain two identical midnights.
  if (Number.isFinite(range.from) && range.from === range.to) {
    return moment.tz(range.from, timezone).add(1, 'day').valueOf() - 1;
  }
  return range.to;
}

function matchesRound(match, selection) {
  const round = match.roundDetails || match.round;
  if (!round || !selection || round.type !== selection.type || round.number !== selection.number) return false;
  if (!selection.pool) return true;
  const { pool } = match;
  return !!pool && pool.name === selection.pool.name
    && (selection.pool.poolLevel == null || pool.poolLevel === selection.pool.poolLevel);
}

function isMatchHidden(match, entries, timezone) {
  return Array.isArray(entries) && entries.some(entry => {
    if (!entry) return false;
    const hasDates = Number.isFinite(entry.from) && Number.isFinite(entry.to);
    const hasRounds = Array.isArray(entry.rounds) && entry.rounds.length > 0;
    const inDates = match.dateTime != null
      && +match.dateTime >= entry.from && +match.dateTime <= getHideRoundEnd(entry, timezone);
    const inRounds = Array.isArray(entry.rounds) && entry.rounds.some(round => matchesRound(match, round));
    // Every selected condition in an entry must match; separate entries remain alternatives.
    return (hasDates || hasRounds || entry.allRounds === true)
      && (!hasDates || inDates)
      && (entry.allRounds === true || !hasRounds || inRounds);
  });
}

export { getHideRoundEnd, isMatchHidden };
